import { IconSVG } from 'components/icon-svg';

/* Иконка паузы */
export const IconPause = ({ width = 36, header = 36, viewBox = '' }) => (
  <IconSVG width={width} height={header} fill="currentColor" viewBox={viewBox}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.7445 5.7285C7.5 6.2085 7.5 6.8385 7.5 8.1V27.9C7.5 29.16 7.5 29.79 7.7445 30.2715C7.96053 30.6947 8.30499 31.0386 8.7285 31.254C9.2085 31.5 9.8385 31.5 11.1 31.5H11.4C12.66 31.5 13.29 31.5 13.7715 31.2555C14.1952 31.0397 14.5397 30.6952 14.7555 30.2715C15 29.7915 15 29.1615 15 27.9V8.1C15 6.84 15 6.21 14.7555 5.7285C14.5397 5.30476 14.1952 4.96028 13.7715 4.7445C13.2915 4.5 12.6615 4.5 11.4 4.5H11.1C9.84 4.5 9.21 4.5 8.7285 4.7445C8.30476 4.96028 7.96028 5.30476 7.7445 5.7285ZM21.2445 5.7285C21 6.2085 21 6.8385 21 8.1V27.9C21 29.16 21 29.79 21.246 30.2715C21.4616 30.6945 21.8055 31.0384 22.2285 31.254C22.7085 31.5 23.3385 31.5 24.6 31.5H24.9C26.16 31.5 26.79 31.5 27.2715 31.2555C27.6947 31.0395 28.0386 30.695 28.254 30.2715C28.5 29.7915 28.5 29.1615 28.5 27.9V8.1C28.5 6.84 28.5 6.21 28.2555 5.7285C28.0397 5.30476 27.6952 4.96028 27.2715 4.7445C26.7915 4.5 26.1615 4.5 24.9 4.5H24.6C23.34 4.5 22.71 4.5 22.2285 4.7445C21.8053 4.96053 21.4599 5.30499 21.2445 5.7285Z"
    />
  </IconSVG>
);

/* Кнопка проигрывать в хеддере */
export const IconPlay = ({ width = 36, header = 36, viewBox = '' }) => {
  return (
    <IconSVG width={width} height={header} fill="currentColor" viewBox={viewBox}>
      <path d="M8.0752 7.524V28.7932C8.0752 29.1802 8.2507 29.4964 8.60282 29.7079C8.74345 29.8136 8.98982 29.8485 9.16532 29.8485C9.34082 29.8485 9.48145 29.8136 9.65807 29.7079L28.0799 19.0901C28.4321 18.8437 28.6424 18.5276 28.6424 18.1406C28.6424 17.7885 28.4309 17.4724 28.0799 17.226L9.65807 6.60825C9.0247 6.1515 8.07632 6.714 8.07632 7.52288L8.0752 7.524Z" />
    </IconSVG>
  );
};

/* Иконка вперед */
export const IconNext = () => {
  return (
    <IconSVG width={36} height={36} fill="currentColor">
      <path fillRule="evenodd" clipRule="evenodd" d="M24.619 18L6 29L6 7L24.619 18Z" />
      <path d="M29 26.997C29 27.8738 28.2645 28.5847 27.3571 28.5847C26.4498 28.5847 25.7143 27.8738 25.7143 26.997L25.7143 9.00288C25.7143 8.12601 26.4498 7.41517 27.3571 7.41517C28.2645 7.41517 29 8.12602 29 9.00289L29 26.997Z" />
    </IconSVG>
  );
};

/* Иконка назад */
export const IconPrev = () => {
  return (
    <IconSVG width={36} height={36} fill="currentColor">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.381 18L29 7L29 29L10.381 18Z" />
      <path d="M6 9.00302C6 8.12615 6.73553 7.41531 7.64286 7.41531C8.55018 7.41531 9.28571 8.12615 9.28571 9.00302V26.9971C9.28571 27.874 8.55018 28.5848 7.64286 28.5848C6.73553 28.5848 6 27.874 6 26.9971V9.00302Z" />
    </IconSVG>
  );
};

/* Иконка списка программ */
export const IconList = () => {
  return (
    <IconSVG width={36} height={36} fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 10.8V13.5H13.5V10.8H27ZM13.5 18.9H27V16.2H13.5V18.9ZM13.5 24.3H27V21.6H13.5V24.3ZM9 13.5H11.7V10.8H9V13.5ZM11.7 18.9V16.2H9V18.9H11.7ZM9 24.3H11.7V21.6H9V24.3Z"
      />
    </IconSVG>
  );
};

export const IconSledePrev = () => {
  return (
    <IconSVG width={15} height={24} fill="white">
      <path d="M12 24L15 21L6 12L15 3L12 0L0 12L12 24Z" />
    </IconSVG>
  );
};

export const IconSldeNext = () => {
  return (
    <IconSVG width={15} height={24} fill="white">
      <path d="M3 0L0 3L9 12L0 21L3 24L15 12L3 0Z" />
    </IconSVG>
  );
};

/* Иконка закрытия всплывающего окна */
export const IconClose = () => {
  return (
    <IconSVG width={18} height={18} fill="#0F1729">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.17471 1.17502C1.63033 0.719411 2.36902 0.719411 2.82464 1.17502L8.99967 7.35008L15.1747 1.17502C15.6303 0.719411 16.369 0.719411 16.8246 1.17502C17.2802 1.63064 17.2802 2.36932 16.8246 2.82494L10.6496 8.99998L16.8246 15.175C17.2802 15.6306 17.2802 16.3693 16.8246 16.8249C16.369 17.2805 15.6303 17.2805 15.1747 16.8249L8.99967 10.6499L2.82464 16.8249C2.36902 17.2805 1.63033 17.2805 1.17471 16.8249C0.719106 16.3693 0.719106 15.6306 1.17471 15.175L7.34977 8.99998L1.17471 2.82494C0.719106 2.36932 0.719106 1.63064 1.17471 1.17502Z"
      />
    </IconSVG>
  );
};

/* Иконка звука */
export const IconVolume = () => {
  return (
    <IconSVG width={36} height={36} fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.728 3.43934C28.3137 2.85356 29.2635 2.85356 29.8493 3.43934C38.0502 11.6403 38.0502 24.9368 29.8493 33.1378C29.2635 33.7236 28.3137 33.7236 27.728 33.1378C27.1422 32.5521 27.1422 31.6023 27.728 31.0166C34.7574 23.9871 34.7574 12.5901 27.728 5.56066C27.1422 4.97487 27.1422 4.02513 27.728 3.43934ZM25.6067 7.68189C25.0209 7.09611 24.0711 7.09611 23.4854 7.68189C22.8996 8.26769 22.8996 9.21742 23.4854 9.80322C28.1716 14.4895 28.1716 22.0875 23.4854 26.7738C22.8996 27.3595 22.8996 28.3093 23.4854 28.8951C24.0711 29.4808 25.0209 29.4808 25.6067 28.8951C31.4646 23.0373 31.4646 13.5398 25.6067 7.68189ZM21.3639 11.9246C20.7782 11.3388 19.8284 11.3388 19.2426 11.9246C18.6568 12.5104 18.6568 13.4602 19.2426 14.046C21.5857 16.3891 21.5857 20.188 19.2426 22.5312C18.6568 23.1169 18.6568 24.0667 19.2426 24.6525C19.8284 25.2384 20.7782 25.2384 21.3639 24.6525C24.8787 21.1378 24.8787 15.4394 21.3639 11.9246ZM16.5 9.06046C16.5 7.17382 14.3176 6.12493 12.8444 7.30351L6.97383 12H4.5C2.01472 12 0 14.0147 0 16.5V19.5C0 21.9853 2.01472 24 4.5 24H6.97383L12.8444 28.6965C14.3176 29.8751 16.5 28.8261 16.5 26.9395V9.06046ZM8.84792 14.3426L13.5 10.6209V25.3791L8.84792 21.6574C8.31597 21.2319 7.65504 21 6.97383 21H4.5C3.67158 21 3 20.3284 3 19.5V16.5C3 15.6715 3.67158 15 4.5 15H6.97383C7.65504 15 8.31597 14.7682 8.84792 14.3426Z"
      />
    </IconSVG>
  );
};

/* Иконка расшарить */
export const IconShare = () => {
  return (
    <IconSVG width={36} height={36} fill="#33353F">
      <g clipPath="url(#clip0_998_8737)">
        <path d="M36 0H0V36H36V0Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 9C21 5.68629 23.6863 3 27 3C30.3136 3 33 5.68629 33 9C33 12.3137 30.3136 15 27 15C25.1941 15 23.5746 14.2022 22.4746 12.9398L14.8681 16.7431C14.9545 17.1484 15 17.5689 15 18C15 18.4311 14.9545 18.8517 14.8681 19.257L22.4746 23.0602C22.4746 23.0602 25.1941 21 27 21C30.3136 21 33 23.6863 33 27C33 30.3136 30.3136 33 27 33C23.6863 33 21 30.3136 21 27C21 26.5689 21.0454 26.1483 21.1318 25.743L13.5254 21.9397C12.4254 23.2021 10.8059 24 9 24C5.68629 24 3 21.3136 3 18C3 14.6863 5.68629 12 9 12C10.8059 12 12.4255 12.7979 13.5255 14.0603L21.1318 10.2571C21.0454 9.85171 21 9.43116 21 9Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_998_8737">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </IconSVG>
  );
};

/* Иконка лайка */
export const IconLike = ({ fill = 'currentColor' }) => {
  return (
    <IconSVG width={50} height={50} fill={fill}>
      <path d="M25.8128 43.4792C25.5729 43.6415 25.29 43.7282 25.0003 43.7282C24.7107 43.7282 24.4277 43.6415 24.1878 43.4792C20.342 40.9104 4.16699 29.4792 4.16699 18.6938C4.16699 4.77709 20.5212 2.54793 25.0003 11.9229C29.4795 2.54793 45.8337 4.77709 45.8337 18.6938C45.8337 29.4813 29.6587 40.9104 25.8128 43.475V43.4792Z" />
    </IconSVG>
  );
};
